import type { RouteRecordRaw } from 'vue-router'
import { guardAcademyAccess, guardAcademyTeam } from '@/config/router/navigationsGuards/guardAcademy'

// Tracked as ACADEMY by the page views. Not an app module (no Module._id): a string id, apart from the numeric ones.
const MODULE_NAME = 'Academy'
const MODULE_ID = 'ACADEMY'

const academyRoutes: Array<RouteRecordRaw> = [
  {
    path: '/academy',
    meta: {
      requiresAuth: true,
    },
    beforeEnter: [guardAcademyAccess],
    children: [
      {
        path: '',
        name: 'AcademyHome',
        component: () => import('@/views/academy/AcademyHome.vue'),
        meta: {
          requiresAuth: true,
          titleTranslationKey: 'modules.academy.title',
        },
      },
      {
        path: 'team',
        name: 'AcademyTeam',
        component: () => import('@/views/academy/AcademyTeam.vue'),
        meta: {
          requiresAuth: true,
          titleTranslationKey: 'modules.academy.team.title',
        },
        beforeEnter: [guardAcademyTeam],
      },
      {
        path: 'team/:resourceId',
        name: 'AcademyTeamMember',
        component: () => import('@/views/academy/AcademyTeamMember.vue'),
        meta: {
          requiresAuth: true,
          titleTranslationKey: 'modules.academy.team.title',
        },
        beforeEnter: [guardAcademyTeam],
      },
      {
        path: ':slug',
        name: 'AcademyLesson',
        component: () => import('@/views/academy/AcademyLessonView.vue'),
        meta: {
          requiresAuth: true,
          titleTranslationKey: 'modules.academy.title',
        },
      },
    ],
  },
]

export default academyRoutes.map(route => ({ ...route, meta: { ...route.meta, moduleName: MODULE_NAME, moduleId: MODULE_ID } }))
